import { Empty, Spin, Tree, type TreeProps } from 'antd';
import React from 'react';

export const MyTree: React.FC<{ loading?: boolean } & TreeProps> = (props) => {
  const { loading = false, treeData, ...restProps } = props;

  return (
    <Spin spinning={loading}>
      {treeData && treeData.length > 0 ? (
        <Tree
          treeData={treeData}
          defaultExpandAll
          fieldNames={{
            key: '_id', // 节点唯一标识
            title: 'name', // 显示名称
            children: 'children', // 子节点字段
          }}
          {...restProps}
        />
      ) : (
        <Empty />
      )}
    </Spin>
  );
};
